<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="../../assets/imgs/qingbaijiang/3/title-bg.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="../../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            设立“中试产业领军人才奖励”，对经认定的中试平台、中试项目孵化成功后落户我区的企业，采取“一事一议”的方式，给予最高500万元、200万元、100万元、50万元奖励支持。
          </div>
        </div>
        <div class="sxcl">
          <img class="top" src="../../assets/imgs/25/title-1.png" alt="" />
          <div class="content" style="padding-bottom: 0.3rem;line-height: 0.44rem;">
            <div class="des" style="margin-top: 0;">（一）支持对象。包括战略科学家、领衔专家、领航企业家、首席技术官4类人才。</div>
            <div class="des">
              <div style="margin-bottom: 0.2rem;">（二）基本条件。申报对象应满足《成都市青白江区中试产业人才目录》中相应的荣誉、经历、业绩要求，并满足以下基本条件：</div>
              <div>1.申报单位应为经认定的中试平台、中试项目孵化成功后落户我区的企业。其中“经认定的中试平台”以区级及以上行业主管部门认定为准，“中试项目孵化成功后落户我区的企业”是指中试项目在经认定的中试平台上，成功孵化转化为企业，并最终落户在我区的主体。<br/> 2.申报单位需在我区完成登记注册，机构住所（经营场所）、税务征管关系及统计关系在青白江区范围内。<br/> 3.人才需与我区相关单位签订正式劳动合同，或开展正式合作，签订正式合作协议（含技术合作协议、项目合作协议等）。<br/> 4.人才为首次申报中试产业领军人才奖励。<br/> 5.人才需协助所在单位成功开展中试项目孵化、成果转化落地，并形成一定的示范引领和辐射带动效应。<br/> 6.特别优秀的人才，或我区急需紧缺的高层次中试人才，经行业主管部门审核通过，可适当放宽申报条件。</div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/25/title-2.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0; padding: 0">
              <div>
                设立“中试产业领军人才奖励”，对经认定的中试平台、中试项目孵化成功后落户我区的企业，采取“一事一议”的方式，在实验室建设、科研经费、项目承担、团队建设等方面提供支持，给予其中的战略科学家、领衔专家、领航企业家、首席技术官最高500万元、200万元、100万元、50万元奖励支持。
              </div>
            </div>
          </div>
        </div>
        <div class="gmlc">
          <img class="top" src="../../assets/imgs/25/title-3.png" alt="" />
          <div class="content">
            <div class="des mar-t3">
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">1</div>
                  <div class="line-title">申报</div>
                </div>
                <div class="line-content">
                  申报单位向区委组织部（区委人才办）提出申请。
                </div>
              </div>
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">2</div>
                  <div class="line-title">受理</div>
                </div>
                <div class="line-content">
                  区委组织部（区委人才办）对申报材料进行形式审查，合格的，予以受理；不合格的，向申报单位作出说明并退回相关材料。
                </div>
              </div>
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">3</div>
                  <div class="line-title">审核</div>
                </div>
                <div class="line-content">
                  区委组织部（区委人才办）将受理合格的申报材料交平台、企业所属园区管委会、镇、街道等载体单位，载体单位初审后出具审核意见报区委人才办。区委组织部（区委人才办）牵头，会同区级相关部门、载体单位、相关专家以及第三方专业评审机构等通过“一事一议”的方式进行评估，形成奖励支持建议后，报区委人才工作领导小组会议审定。
                </div>
              </div>
              <div class="line-item">
                <div class="line-top">
                  <div class="line-num">4</div>
                  <div class="line-title">资金拨付</div>
                </div>
                <div class="line-content">
                  审定通过后，区委组织部（区委人才办）按程序将相关资金拨予相关单位，由相关单位向人才发放。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="contact" style="margin-top: 0.8rem">
          <img class="top" src="../../assets/imgs/25/title-4.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028—61760181">028—61760181</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              区委组织部（区委人才办）
            </div>
            <div class="site">
              <span class="label">地址：</span>
              青江中路183号
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="code" src="../assets/imgs/54/code.png" />
          <img class="text" src="../assets/imgs/54/text.png" />
        </div> -->
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
    height: 5.58rem;
  }

  .technological-process {
    transform: translateY(-1.9rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        // font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;

        text-align: left;
      }
    }
    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            min-width: 3.74rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.4rem;
        .title {
          font-size: 0.35rem;
          color: #333;
          font-weight: 600;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem;
          padding: 0.22rem;
          font-weight: 500;
          margin-top: 0.25rem;
          position: relative;
        }
      }
    }

    .sbcl {
      position: relative;
      margin-top: 0.22rem;
      line-height: 0.44rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;
      // line-height: 0.44rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.59rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;

              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3A73FF;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .code {
        width: 1.94rem;
        height: 1.94rem;
      }

      .text {
        height: 1.75rem;
      }
    }
  }
}
</style>
